import api from './base';
import { GetListType } from './types/GetListType';

class CustomCfgHwEventsApi {
  public getCustomCfgHwEvents = async (companyId: string, params?: any) => {
    const response = await api.get(`/custom-cfg-hw-events`, {
      params: { ...params, companyId, DisplayEvent: true },
    });

    return response.data.data;
  };
}

export default new CustomCfgHwEventsApi();
